import React from "react";
import { Link } from "react-router-dom";

const Blogs = () => {
  return (
    <div className="w-full min-h-screen flex blogs items-center justify-center">
      <h2
        data-aos="zoom-in"
        data-aos-delay="1000"
        className="text-base-100 text-5xl content"
      >
        <span className="text-secondary">Commi</span>ng Soon <br />
        <Link className="btn  btn-secondary btn-outline" to={"/"}>
          Back
        </Link>
      </h2>
    </div>
  );
};

export default Blogs;
